module.exports = __webpack_public_path__ + "5ecbe3cd5ba1d8d113e4fa57fb9f2cd9.MP3";